import { Routes } from '@angular/router';
import { MainLayoutComponent } from '@app/shared/layouts';
import { Role } from '@core/types/role.interface';
import { authGuard } from '@app/core/auth';
import { preventLoggedInGuard } from '@core/guards/prevent-logged.guard';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.routes').then((n) => n.homeRoutes),
        data: { roles: [Role.Admin, Role.User], preload: true },
      },
      {
        path: 'credits',
        loadChildren: () => import('./features/credits/credits.routes').then((n) => n.CREDITS_ROUTES),
        data: { breadcrumb: 'Créditos', roles: [Role.Admin, Role.User], preload: true },
      },
      {
        path: 'finances',
        loadChildren: () => import('./features/finances/finances.routes').then((n) => n.FINANCES_ROUTES),
        data: { breadcrumb: 'Finanzas', roles: [Role.Admin, Role.User] },
      },
      {
        path: 'inventories',
        loadChildren: () => import('./features/inventories/inventories.routes').then(r => r.INVENTORIES_ROUTES),
        data: { breadcrumb: 'Inventarios', roles: [Role.Admin, Role.User] }
      },
      {
        path: 'purchases',
        loadChildren: () => import('./features/purchases/purchases.routes').then(r => r.PURCHASES_ROUTES),
        data: { breadcrumb: 'Compras', roles: [Role.Admin, Role.User] }
      },
      {
        path: 'products',
        loadChildren: () => import('./features/products/products.routes').then(r => r.PRODUCTS_ROUTES),
        data: { breadcrumb: 'Productos', roles: [Role.Admin, Role.User] }
      }
    ],
  },
  {
    path: 'auth',
    canActivate: [preventLoggedInGuard],
    loadChildren: () => import('./core/auth/auth.routes').then((e) => e.AUTH_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
